import StackTrace from 'stacktrace-js';

interface FormattedError {
  message: string;
  stack: string;
}

export async function formatStackTrace(
  error: unknown
): Promise<FormattedError> {
  let message = error?.toString?.() || 'Undefined error';

  let stack = '';
  if (error instanceof Error) {
    try {
      const stackFrames = await StackTrace.fromError(error);
      stack = stackFrames.map((frame) => frame.toString()).join('\n');
    } catch (e) {
      stack = `Error parsing stack trace: ${e}\nOriginal stack trace:\n${error.stack}`;
    }
  }

  return { message, stack };
}
